<template>
  <div class="testimonial">
    <div class="d-flex text-box">
      <b-form-textarea
        v-model="textAnswer"
        @update="saveText"
        cols="85"
        rows="5"
        placeholder="Enter your response here"
        debounce="200"
      />
      <div class="testimonial-progress">
        <div class="slider">
          <div class="track" :style="progressHeight">&nbsp;</div>
        </div>
        <div class="caption">Detail<br />Strength</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'
import { useValidationStore } from '@/survey/stores/ValidationStore.ts'

export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      textAnswer: null,
      desiredTestimonialLength: 225,
    }
  },
  computed: {
    ...mapState(useSurveyResponseStore, ['surveyResponses', 'findResponseByQuestionId']),
    ...mapState(useValidationStore, ['addError', 'registerValidationFunction', 'validate']),
    response() {
      return this.findResponseByQuestionId(this.question.id)
    },
    progressHeight() {
      return `height: ${(this.textAnswer?.length / this.desiredTestimonialLength) * 100}%`
    },
  },
  mounted() {
    this.registerValidationFunction(this.question.id, this._validate)
    this.textAnswer = this.response?.text_answer || ''
  },
  methods: {
    saveText() {
      this.validate(this.question.id)

      if (this.textAnswer === this.response?.text_answer || this.hasError) return

      const responseData = {
        question_id: this.question.id,
        response_id: this.response?.id,
        answer_id: this.question.answers[0].id,
        text_answer: this.textAnswer,
      }

      this.$emit('change', responseData)
    },
    _validate() {
      if (this.question.required && !this.textAnswer) {
        this.addError(this.question.id, 'Please fill in the text field')
      }
    },
  },
}
</script>
<style lang="sass" scoped>
.text-box
  textarea
    margin-right: 9px
  .testimonial-progress
    position: relative
    text-align: center
    .slider
      position: relative
      left: calc(50% - 3px)
      background: #F5F5F5
      border-radius: 5px
      overflow: hidden
      height: calc(100% - 30px)
      width: 6px
      margin-bottom: 7px
      .track
        position: absolute
        bottom: 0px
        background: #28A745
        width: 100%
    .caption
      font-size: 10px
      line-height: 12px
      color: #6C757D
@media screen and (max-width: 500px)
  textarea
    height: 20em
  .testimonial-progress
    display: none
</style>
